import type { ModalDialogProps } from "@atlaskit/modal-dialog";

export const MODAL_CONFIG: ModalDialogProps = {
	width: 'x-large',
	autoFocus: false,
}

export const SERVICE_COLLECTION_PRICING_PAGE_URL =
	'https://www.atlassian.com/collections/service/pricing';

export const JSM_PRICING_PAGE_URL =
'http://www.atlassian.com/software/jira/service-management/product-pricing';

export const INCIDENTS_SLACK_INTEGRATION_VIDEO_URL = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;
